module.exports = __webpack_public_path__ + "img/piano-keyboard.32435717.svg";